import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllRecharge } from "../../../../features/admin/recharge_management/user_recharge/Slice";
import { useSearchParams } from "react-router-dom";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const recharge = useSelector(
    (state) => state.recharge_managements.user_recharge,
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const [searchDistrict, setSearchDistrict] = useState("");
  const [vehicleCategory, setVehicleCategory] = useState("");
  const [searchVehicleCategory, setSearchVehicleCategory] = useState("");

  console.log(vehicleCategory, "vehicleCategory");

  const [status, setStatus] = useState("");
  const [name, setName] = useState("");
  const [ready, setReady] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  useEffect(() => {
    const queryStatus = searchParams.get("status");

    if (queryStatus !== null) {
      setStatus(Number(queryStatus));

      const params = new URLSearchParams(searchParams);
      params.delete("status");
      setSearchParams(params, { replace: true });
    }

    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;

    fetch();
  }, [name, status, ready, searchDistrict, from, to, vehicleCategory]);

  const fetch = async (page = recharge?.current_page) => {
    await dispatch(
      GetAllRecharge({
        name: name,
        district_id: searchDistrict?.value,
        vehicle_category_id: vehicleCategory?.value,
        status: status,
        from,
        to,
        page: page,
        per_page: recharge?.per_page,
      }),
    );
  };

  return {
    recharge,
    name,
    setName,
    status,
    setStatus,
    fetch,
    modalMessage,
    modalShow,
    setModalShow,
    setSearchDistrict,
    searchDistrict,
    from,
    setFrom,
    to,
    setTo,
    vehicleCategory,
    setVehicleCategory,
    searchVehicleCategory,
    setSearchVehicleCategory,
  };
};
